<template>

    <div class="modalTabWindow">
        <section class="mainSubnav">
            <nav>
                <a :class="{active:activeTab=='activeTab1'}" @click="activeTab='activeTab1'">Use case</a>
                <a :class="{active:activeTab=='activeTab2'}" @click="activeTab='activeTab2'">Consortium</a>
                <a :class="{active:activeTab=='activeTab3'}" @click="activeTab='activeTab3'">Contacten</a>
                <a :class="{active:activeTab=='activeTab4'}" @click="activeTab='activeTab4'">Panelleden</a>
            </nav>
        </section>

        <div class="tabContainer" :class="activeTab">

            <div class="defaultTab tab1"> 
                <TabUsecase :usecase="usecase"  v-if="usecase"/>
            </div>

            <div class="defaultTab tab2"> 
                    <TabConsortium :consortium="usecase.Consortium"  v-if="usecase"/>
            </div>

            <div class="defaultTab tab3">
                    <TabContacts :contacts="usecase.Contacts"  v-if="usecase"/>
            </div>

            <div class="defaultTab tab4">
                    <TabPanelmembers :panelmembers="usecase.Panelmembers"  v-if="usecase"/>
            </div>
            
        </div>
    </div>
</template>

<script>
import TabConsortium from './TabConsortium.vue';
import TabContacts from './TabContacts.vue';
import TabUsecase from './TabUsecase.vue';
import TabPanelmembers from './TabPanelmembers.vue';
export default {
    components: {
        TabConsortium,
        TabContacts,
        TabUsecase,
        TabPanelmembers
    },
    props: {
        data: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            activeTab: 'activeTab1',
            usecase: null
        }
    },
    methods: {
        async loadData() {
            const res = await this.callApi('get', `/usecases/details/${this.data.usecase_id}`);
            this.usecase = res.data.result;
        }
    },
    mounted() {
        console.log(this.data);
        this.loadData()
    }
}
</script>

